const resource = "messages";

const defaultModel = {
	name: '',
	subject: '',
	header_text: '',
	message: '\n\nAccess Your Pass:\n{{dashboardUrl}}\n\nOpt-out here:\n{{unsubscribeLink}}',
	data: {},
	send_email: 0,
	send_text: 1,
	send_feed: 0,
	partner_user_filters: {},
	reschedule: 0,
	reschedule_value: '',
	reschedule_count: 0,
	rescheduled_message_id: 0,
	scheduled_at: '',
	reschedule_at: '0000-00-00 00:00:00',
	status: 'draft',
	email_template_id: 0,
};

export default ($axios) => ({
	// GET
	getModel() {
		return defaultModel;
	},
	getMessage(id) {
		return $axios.get(`/${resource}/${id}`);
	},
	getMessageRecipients(id, params) {
		return $axios.get(`/${resource}/${id}/recipients`, { params })
	},
	// PUT
	updateMessage(messageData) {
		return $axios.put(`/${resource}/${messageData.id}`, messageData)
	},
	// POST
	createMessage(messageData) {
		return $axios.post(`/${resource}`, messageData)
	},
	sendTestMessage(id, data) {
		return $axios.post(`/${resource}/${id}/sendTestMessage`, data)
	}
});
